import { Link } from 'react-router-dom';
import SEOHead from '@/components/SEOHead';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Breadcrumb from '@/components/Breadcrumb';
import { categories } from '@/mocks/categories';

const breadcrumbItems = [
  { label: '首页', href: '/' },
  { label: '关于我们' },
];

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '猎奇吃瓜',
  url: 'http://odki7b.com/',
  logo: 'http://odki7b.com/logo.png',
  description:
    '猎奇吃瓜是一个中文娱乐八卦、猎奇趣闻聚合平台，主打新鲜吃瓜八卦、冷门趣味爆料及无压力围观趣事。',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: '商务合作',
    email: 'hello@odki7b.com',
  },
};

const webpageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '关于我们 - 猎奇吃瓜',
  description:
    '了解猎奇吃瓜的品牌故事、平台定位、核心栏目以及联系方式。猎奇吃瓜 - 每日新鲜吃瓜八卦。',
  url: 'http://odki7b.com/about',
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '首页',
      item: 'http://odki7b.com/',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: '关于我们',
      item: 'http://odki7b.com/about',
    },
  ],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '猎奇吃瓜是什么平台？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '猎奇吃瓜是一个中文娱乐八卦、猎奇趣闻聚合平台，主打新鲜吃瓜八卦、冷门趣味爆料及无压力围观趣事。每日更新猎奇向娱乐梗与新奇八卦合集，为围观心态提供解压谈资与社交分享素材。',
      },
    },
    {
      '@type': 'Question',
      name: '猎奇吃瓜的内容来源可靠吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们严格筛选信息来源，标注信息出处，确保内容真实可靠。同时提醒用户理性吃瓜，对未经证实的爆料保持审慎态度。',
      },
    },
    {
      '@type': 'Question',
      name: '如何向猎奇吃瓜投稿爆料？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过邮件 hello@odki7b.com 向我们投稿，我们会保护爆料者隐私，对有价值的线索进行调查核实后发布。',
      },
    },
    {
      '@type': 'Question',
      name: '猎奇吃瓜支持商务合作吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '支持。如有商务合作意向，请发送邮件至 hello@odki7b.com，我们的商务团队会在24小时内与您取得联系。',
      },
    },
  ],
};

export default function AboutPage() {
  return (
    <>
      <SEOHead
        title="关于我们 - 猎奇吃瓜 | 品牌介绍与联系方式"
        description="了解猎奇吃瓜的品牌故事、平台定位、核心栏目以及联系方式。猎奇吃瓜每日更新新鲜吃瓜八卦、冷门趣味爆料及无压力围观趣事。"
        keywords="猎奇吃瓜,关于我们,品牌介绍,联系方式,商务合作,爆料投稿,平台定位"
        canonical="http://odki7b.com/about"
        ogImage="http://odki7b.com/og-about.jpg"
        schema={[orgSchema, webpageSchema, breadcrumbSchema, faqSchema]}
      />

      <Navbar />

      <main>
        {/* About Hero */}
        <section className="relative min-h-[360px] md:min-h-[420px] flex items-end overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20floating%20social%20elements%20and%20speech%20bubbles%2C%20coral%20and%20amber%20color%20palette%2C%20modern%20digital%20art%20style%2C%20friendly%20and%20approachable%20atmosphere%2C%20soft%20glow%20lighting&width=1600&height=700&seq=about-hero&orientation=landscape"
              alt="关于猎奇吃瓜"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/20" />
          </div>

          <div className="relative w-full px-4 md:px-6 lg:px-10 pb-10 md:pb-14 pt-24 md:pt-32">
            <div className="mb-4">
              <Breadcrumb items={breadcrumbItems} />
            </div>
            <h1 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white">
              关于猎奇吃瓜
            </h1>
            <p className="mt-3 text-sm md:text-base text-white/80 max-w-xl">
              每日新鲜吃瓜八卦、冷门趣味爆料及无压力围观趣事，为围观心态提供解压谈资与社交分享素材
            </p>
          </div>
        </section>

        {/* Brand Intro */}
        <section className="bg-background-50 py-10 md:py-16">
          <div className="w-full px-4 md:px-6 lg:px-10">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-start">
              <div className="lg:col-span-3">
                <span className="text-xs font-medium text-foreground-500 border border-foreground-300 px-2 py-1 rounded">
                  关于我们
                </span>
                <div className="mt-4">
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                    猎奇吃瓜
                  </h2>
                  <p className="text-foreground-500 text-lg">轻松围观</p>
                </div>
                <div className="mt-5 space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                  <p>
                    猎奇吃瓜成立于2025年，是一个专注于中文娱乐八卦与猎奇趣闻的内容聚合平台。
                    我们的初衷很简单：在信息爆炸的时代，为用户筛选出真正有趣、有价值的内容，
                    让每一次"吃瓜"都变成一次愉快的体验。
                  </p>
                  <p>
                    我们拒绝无意义的重复信息和垃圾内容，坚持每日精选更新，覆盖娱乐八卦、社会奇闻、
                    明星爆料、猎奇趣闻、网络热梗和解压谈资等多个领域。每一篇文章都经过严格筛选，
                    确保为读者带来新鲜感与阅读价值。
                  </p>
                  <p>
                    "猎奇吃瓜"这个名字源自中文互联网热词"吃瓜"——指围观他人八卦趣事的行为。
                    我们希望通过这个平台，让每个人都能在忙碌的生活中找到片刻轻松，
                    以无压力的心态享受围观带来的解压乐趣。
                  </p>
                </div>
                <div className="mt-6">
                  <a
                    href="mailto:hello@odki7b.com"
                    className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 underline underline-offset-4"
                  >
                    联系商务
                    <i className="ri-arrow-right-line text-xs" />
                  </a>
                </div>
              </div>
              <div className="lg:col-span-2 flex gap-3 justify-end">
                <div className="w-28 h-28 md:w-36 md:h-36 rounded-xl overflow-hidden shadow-md shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Minimalist%20modern%20logo%20design%20with%20watermelon%20and%20magnifying%20glass%20elements%2C%20warm%20coral%20and%20green%20colors%2C%20clean%20white%20background%2C%20flat%20design%20style%2C%20friendly%20and%20playful&width=400&height=400&seq=about-logo&orientation=squarish"
                    alt="猎奇吃瓜品牌"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-36 h-48 md:w-44 md:h-60 rounded-xl overflow-hidden shadow-md -mt-4">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20workspace%20with%20team%20collaboration%2C%20warm%20natural%20lighting%20through%20windows%2C%20coral%20and%20amber%20accent%20decorations%2C%20warm%20and%20energetic%20atmosphere%2C%20editorial%20lifestyle%20photography&width=500&height=700&seq=about-team&orientation=portrait"
                    alt="团队工作场景"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-10 md:mt-14 pt-8 border-t border-background-200">
              <div className="text-center">
                <p className="text-3xl md:text-4xl font-bold text-primary-500">5000+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">累计爆料文章</p>
              </div>
              <div className="text-center">
                <p className="text-3xl md:text-4xl font-bold text-accent-500">200w+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">月均阅读量</p>
              </div>
              <div className="text-center">
                <p className="text-3xl md:text-4xl font-bold text-secondary-600">50w+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">活跃围观用户</p>
              </div>
              <div className="text-center">
                <p className="text-3xl md:text-4xl font-bold text-foreground-700">365</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">全年无休更新</p>
              </div>
            </div>
          </div>
        </section>

        {/* Core Columns */}
        <section className="bg-background-100 py-10 md:py-16">
          <div className="w-full px-4 md:px-6 lg:px-10">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                核心栏目 <span className="text-secondary-600">特色矩阵</span>
              </h2>
              <p className="text-sm text-foreground-500 mt-2">六大频道，覆盖你的全部吃瓜需求</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 hover:shadow-md transition-all duration-300"
                >
                  <div className="relative h-40 overflow-hidden">
                    <img
                      src={cat.image}
                      alt={cat.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                    <div className="absolute bottom-3 left-3">
                      <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-white/90 text-foreground-800">
                        {cat.name}
                      </span>
                    </div>
                  </div>
                  <div className="p-4">
                    <p className="text-sm text-foreground-600 line-clamp-2">{cat.description}</p>
                    <div className="flex items-center gap-1 mt-3 text-xs text-primary-600 font-medium">
                      进入频道
                      <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="bg-background-50 py-10 md:py-16">
          <div className="w-full px-4 md:px-6 lg:px-10">
            <div className="max-w-3xl mx-auto">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6 md:mb-8 text-center">
                常见问题
              </h2>
              <div className="space-y-4">
                {[
                  {
                    q: '猎奇吃瓜是什么？',
                    a: '猎奇吃瓜是一个中文娱乐八卦、猎奇趣闻聚合平台，主打新鲜吃瓜八卦、冷门趣味爆料及无压力围观趣事。每日更新猎奇向娱乐梗与新奇八卦合集。',
                  },
                  {
                    q: '猎奇吃瓜的内容可信吗？',
                    a: '我们严格筛选信息来源，标注信息出处，确保内容真实可靠。同时提醒用户理性吃瓜，对未经证实的爆料保持审慎态度。',
                  },
                  {
                    q: '如何向猎奇吃瓜投稿爆料？',
                    a: '您可以通过邮件 hello@odki7b.com 向我们投稿，我们会保护爆料者隐私，对有价值的线索进行调查核实后发布。',
                  },
                  {
                    q: '猎奇吃瓜支持商务合作吗？',
                    a: '支持。如有商务合作意向，请发送邮件至 hello@odki7b.com，我们的商务团队会在24小时内与您取得联系。',
                  },
                ].map((faq, idx) => (
                  <details
                    key={idx}
                    className="group bg-background-100 rounded-xl border border-background-200 overflow-hidden"
                  >
                    <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                      <span className="text-sm md:text-base font-semibold text-foreground-900">
                        {faq.q}
                      </span>
                      <i className="ri-add-line text-foreground-400 group-open:ri-subtract-line text-lg shrink-0 ml-4" />
                    </summary>
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="relative py-14 md:py-20 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20soft%20particles%20and%20glow%20orbs%2C%20coral%20and%20amber%20tones%2C%20inviting%20professional%20atmosphere%2C%20modern%20digital%20art%2C%20subtle%20texture&width=1600&height=600&seq=about-cta&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/50" />
          </div>
          <div className="relative w-full px-4 md:px-6 lg:px-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-white">
                  商务合作 & 爆料入口
                </h2>
                <p className="mt-3 text-sm text-white/70 leading-relaxed max-w-md">
                  无论是独家爆料、商务合作还是意见建议，我们都期待听到您的声音。猎奇吃瓜始终秉持开放、透明的态度，欢迎各界朋友与我们联系。
                </p>
                <div className="mt-6 flex flex-wrap gap-3">
                  <a
                    href="mailto:hello@odki7b.com"
                    className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 text-foreground-950 rounded-full text-sm font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap"
                  >
                    联系我们
                    <span className="w-5 h-5 rounded-full bg-foreground-950 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-accent-500 text-xs" />
                    </span>
                  </a>
                  <a
                    href="mailto:hello@odki7b.com"
                    className="inline-flex items-center gap-2 px-5 py-2.5 border border-white/30 text-white rounded-full text-sm font-medium hover:bg-white/10 transition-colors whitespace-nowrap"
                  >
                    匿名爆料
                  </a>
                </div>
              </div>
              <div className="hidden lg:block space-y-3">
                <div className="flex items-center gap-3 text-white/80 text-sm">
                  <i className="ri-mail-line text-accent-400" />
                  <span>商务合作：hello@odki7b.com</span>
                </div>
                <div className="flex items-center gap-3 text-white/80 text-sm">
                  <i className="ri-mail-send-line text-accent-400" />
                  <span>爆料投稿：hello@odki7b.com</span>
                </div>
                <div className="flex items-center gap-3 text-white/80 text-sm">
                  <i className="ri-feedback-line text-accent-400" />
                  <span>意见反馈：hello@odki7b.com</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
